import { AbstractControl } from '@angular/forms';

export function BudgetFinansieringNotChanged(totalFinansiering: number) {
  return (control: AbstractControl) => {
    if (control.value) {
      const soktBidrag = control.value;
      return soktBidrag === totalFinansiering
        ? undefined
        : { BudgetFinansieringNotChanged: true };
    }
  };
}
